import { linkToParentDashboard } from "../../links";

export function linkToMonitoringPage() {
  return `${linkToParentDashboard()}/monitoring`;
}
